import styled from 'styled-components';

const TestContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export default TestContainer;
